import {Range} from "../../../../../../pkg/slate.js";
export const isExpanded = (range) => !!range && Range.isExpanded(range);
